/* eslint eqeqeq: "off" */
/* eslint no-unused-vars: "off" */
import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { Col, Row, Modal, Image } from "antd";
import {
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { isEmpty } from "lodash";
import adminLogo from "../../assets/images/table-header-admin.svg";
import accountantLogo from "../../assets/images/table-header-accountant.svg";
import stockLogo from "../../assets/images/table-header-stockManager.svg";
import salesLogo from "../../assets/images/table-header-salesman.svg";

import { ToastContainer } from "react-toastify";
import { useHistory } from "react-router";

const UserRole = () => {
  const history = useHistory();

  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";

  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const usersList = { userId: userId, organizationId: userInfoDetails };

  //   useEffect(() => {
  //     setLoading(true);
  //     setTimeout(() => {
  //       setLoading(false);
  //     }, 2000);
  //   }, []);

  //Reducer state

  //   const {
  //     user_role_list = [],
  //   } = useSelector((state) => state.Organisation);

  console.log(usersList, "usersList");
  //State data section
  const [pageRouting, setPageRouting] = useState(false);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>User Role | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid pb-[10px] rounded-md bg-[#ffffff] pb-10">
        <Col
          span={24}
          className="p-2.5 border border-b-1 border-x-0 border-t-0"
        >
          <div className="flex justify-between pl-[14px] pr-[20px] mt-3">
            <div className="flex">
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <div className="ml-2 account-sub-header">
                <h1 className="text-[18px] mb-[1px] font-semibold leading-tight">
                  User Roles
                </h1>
              </div>
            </div>
          </div>
        </Col>

        <Col
          md={24}
          sm={24}
          lg={24}
          xs={24}
          className="add-user-role-access-main"
        >
          {/* <Row> */}
          <table className="table-user-role-serial">
            <thead
              style={{
                position: "sticky",
                top: 0,
                background: "#ffffff",
                boxShadow: "0px 0px 1px 1px lightgray"
              }}
            >
              <tr
                className="font-normal"
                style={{
                  fontFamily: "Poppins",
                  borderBottom: "1px solid #ebeaea",
                }}
              >
                <th className="w-[12%] text-start table-user-role-head pr-3 pl-3">
                  <h1 className="mt-2">Features </h1>
                </th>
                <th className="w-[15%] text-start table-user-role-head pr-3 pl-3">
                  <h1 className="mt-2">Permissions </h1>
                </th>
                <th className="w-[15%] table-user-role-head pr-3 pl-3">
                  <div className=" flex justify-between">
                    <h1 className="mt-6">Admin </h1>
                    <Image
                      src={adminLogo}
                      preview={false}
                      height={50}
                      width={66}
                      className="mt-4"
                    />
                  </div>
                </th>
                <th className="w-[15%] table-user-role-head pr-3 pl-3 p-2">
                  <div className="flex justify-between">
                    <h1 className="mt-6">Accountant </h1>
                    <Image
                      src={accountantLogo}
                      preview={false}
                      height={50}
                      width={66}
                      className="mt-4"
                    />
                  </div>
                </th>
                <th className="w-[15%] table-user-role-head pr-3 pl-3  p-2">
                  <div className="flex justify-between">
                    <h1 className="mt-6"> Stock Manager </h1>
                    <Image
                      src={stockLogo}
                      preview={false}
                      height={50}
                      width={66}
                      className="mt-6"
                    />
                  </div>
                </th>
                <th className="w-[15%] table-user-role-head pr-3 pl-3  p-2">
                  <div className="flex justify-between">
                    <h1 className="mt-6">Sales Executive</h1>
                    <Image
                      src={salesLogo}
                      preview={false}
                      height={50}
                      width={66}
                     className="mt-6"
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody
              style={{
                fontFamily: "Poppins",
                fontSize: "12px",
                marginTop: "40px",
              }}
            >
              {/* Items */}
              <tr className="table-user-role-row">
                <td className="h-[60px] pl-3 table-user-role-data font-semibold">
                  Items
                </td>
                <td className="table-user-role-data">
                  <tr className="flex flex-col text-[#687e96] text-[11px]">
                    <td className="table-user-role-permission-data">Create</td>
                    <td className="table-user-role-permission-data">Edit</td>
                    <td className="table-user-role-permission-data">View</td>
                    <td className="table-user-role-permission-data">Delete</td>
                    {/* <td className="table-user-role-permission-data"> */}
                    <td className="p-[6px]">Share Images</td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                  </tr>
                </td>
              </tr>
              {/* Purchase vouchers */}
              <tr className="table-user-role-row">
                <td className="h-[60px] pl-3 table-user-role-data">
                  <div>
                    <h1 className="font-semibold text-[13px]">
                      Purchase Vouchers
                    </h1>
                    <p>(Purchase, Payment Out, Purchase Order, Debit Note)</p>
                  </div>
                </td>
                <td className="table-user-role-data">
                  <tr className="flex flex-col text-[#687e96] text-[11px]">
                    <td className="table-user-role-permission-data">
                      Create
                      {/* Create (includes edit of item details) */}
                    </td>
                    <td className="table-user-role-permission-data">Edit</td>
                    <td className="table-user-role-permission-data">View</td>
                    <td className="p-[6px]">Delete</td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                  </tr>
                </td>
              </tr>
              {/* Sales Vouchers */}
              <tr className="table-user-role-row">
                <td className="h-[60px] pl-3 table-user-role-data">
                  <div>
                    <h1 className="font-semibold text-[13px]">
                      Sales Vouchers
                    </h1>
                    <p>
                      (Sales, Quotation, Proforma, Payment In, Credit Note,
                      Delivery Chalan Online Store)
                    </p>
                  </div>
                </td>
                <td className="table-user-role-data">
                  <tr className="flex flex-col text-[#687e96] text-[11px]">
                    <td className="table-user-role-permission-data">
                      Create
                      {/* Create (includes edit of item details) */}
                    </td>
                    <td className="table-user-role-permission-data">Edit</td>
                    <td className="table-user-role-permission-data">View</td>
                    <td className="p-[6px]">Delete</td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-both-data text-center">
                      Y/N
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                  </tr>
                </td>
              </tr>
              {/* Stock adjustment */}
              <tr className="table-user-role-row">
                <td className="font-semibold pl-3 table-user-role-data">
                  Stock Adjustment
                </td>

                <td className="p-[6px] text-[11px] text-[#687e96]">Create</td>
                <td className="table-user-role-access-given-data text-center">
                  YES
                </td>
                <td className="table-user-role-access-given-data text-center">
                  YES
                </td>
                <td className="table-user-role-access-given-data text-center">
                  YES
                </td>

                <td className="table-user-role-access-denied-data text-center">
                  NO
                </td>
              </tr>
              {/* Sales Vouchers */}
              <tr className="table-user-role-row">
                <td className="pl-3 table-user-role-data">
                  <div>
                    <h1 className="font-semibold text-[13px]">
                      Company Settings
                    </h1>
                  </div>
                </td>
                <td className="table-user-role-data">
                  <tr className="flex flex-col text-[#687e96] text-[11px]">
                    <td className="table-user-role-permission-data">
                      Invoice Settings
                      {/* Create (includes edit of item details) */}
                    </td>
                    <td className="table-user-role-permission-data">
                      Item Settings{" "}
                    </td>
                    <td className="table-user-role-permission-data">
                      Store Settings{" "}
                    </td>
                    <td className="table-user-role-permission-data">
                      Company Settings{" "}
                    </td>
                    <td className="table-user-role-permission-data">
                      Account/Profile Settings{" "}
                    </td>
                    <td className="table-user-role-permission-data">
                      UPI Payment Link{" "}
                    </td>
                    <td className="table-user-role-permission-data">
                      Delete Data{" "}
                    </td>
                    <td className="p-[6px]">Subscription Plan </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  {" "}
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                  </tr>
                </td>
                <td className="table-user-role-data">
                  <tr className="flex flex-col">
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-given-data text-center">
                      YES
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                    <td className="table-user-role-access-denied-data text-center">
                      NO
                    </td>
                  </tr>
                </td>
              </tr>
            </tbody>
          </table>
          {/* </Row> */}
        </Col>
      </Row>
      <Modal
        open={pageRouting}
        onOk={() => {
          setPageRouting(false);
          history.push({
            pathname: "/settings/manage-users",
            state: {
              settingsMode: true,
            },
          });
        }}
        closeIcon
        maskClosable={false}
        rootClassName="p-15 h-[300px]"
        okText={"Yes, Leave"}
        cancelText={"No, Stay"}
        onCancel={() => setPageRouting(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <div className="mr-3">
              <OkBtn />
            </div>
            <CancelBtn />
          </div>
        )}
        width={500}
      >
        <div className="text-center w-[100%]">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to leave this page?
          </h1>
          <p className="text-center text-[14px] mt-2">
            All unsaved changes will be lost!
          </p>
        </div>
      </Modal>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};
UserRole.propTypes = {
  location: PropTypes.any,
};

export default UserRole;
